import { useState,useEffect } from 'react';
import { Outlet,useLocation } from 'react-router-dom';

export default function Setting(){
const [ itemObj , setItemObj] = useState({}); //設定當前點了table哪一筆tr物件(CRUD)
const [ action , setAction ] = useState(''); //設定當前是做哪個動作(CRUD)
const [ currentKeyword,setCurrentKeyword] = useState(''); //紀錄keyword
  return (
    <>
        <Outlet context={{itemObj,setItemObj,action,setAction,setCurrentKeyword,currentKeyword}} />
    </>
  );
}